<template>
  <div class="modal fade show" ref="vuemodal" id="detachProductSetsConstructModal" tabindex="-1" aria-hidden="false">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('inventory.product_disassembly')}}</h5>
          <button type="button" class="close" @click="close">&times;</button>
        </div>
        <div class="modal-body" >
          <div class="form-group">
            <div class="form-inline d-flex">
              <div class="search-product" >
                <v-select
                  :options="productSetComputed"
                  @input="onSelectProduct"
                  :close-on-select="false"
                  :placeholder="translations('common.search')"
                  :clearable="false"
                  :clearSearchOnSelect="false"
                  label="nameCustom"
                  v-model="activeSelect"
                >
                  <span slot="no-options" class="px-3">
                    {{translations('inventory.message_notification_stock_not_found')}}
                  </span>
                  <template #option="product">
                    <div class="option-product-set">
                      {{ product.nameCustom }}
                      <img v-if="product.quantity <= 0" :src="require('../assets/img/stock-warning.png')" />
                    </div>
                  </template>
                </v-select>

              </div>
              <div class="form-group ml-3 d-flex align-items-center">
                <span class="text-nowrap mr-1">{{translations('inventory.decomposition_date')}}</span>
                <input v-model="setting_at" type="date" class="form-control">
              </div>
              <div class="form-group ml-3 d-flex align-items-center">
                <span class="text-nowrap mr-1">{{translations('inventory.remarks')}}</span>
                <input v-model="comment" type="text" class="form-control">
              </div>
            </div>
          </div>
          <div class="content-product-detach border-top">
            <template v-for="(productParent, i) in productComputed">
              <div class="item-product d-flex justify-content-between p-3" :key="i">
                <div class="name-product d-flex align-items-center">
                  {{ productParent.nameCustom }}
                </div>
                <div class="d-flex align-items-center action-quantity">
                  <i class="fas fa-minus mr-2 cursor-pointer" @click="onActionQuantity(i, -1)"></i>
                  <input type="number" v-model="productParent.quantity_need_detach" @change="changeQuantityProduct($event,i)" class="form-control">
                  <i class="fas fa-plus ml-2 cursor-pointer" @click="onActionQuantity(i, 1)"></i>
                </div>
                <div class="d-flex align-items-center quanlity-max">
                  {{translations('inventory.quantity_stock')}}：{{ productParent.quantity }} セット
                </div>
                <div class="d-flex align-items-center open-child">
                  <div class="cursor-pointer mr-2" >
                    <div @click="toggleDropdown(i)">
                      (<i :class="indexOpenChild == i ? 'fas fa-caret-up' : 'fas fa-caret-down'"></i>
                      {{productParent.childs.length}} {{ translations('inventory.parts_included') }})
                    </div>
                    <table v-if="indexOpenChild == i" class="table table-striped table-align-middle">
                      <thead>
                        <tr>
                          <th>{{ translations('inventory.jan_code') }}</th>
                          <th>{{ translations('inventory.model') }}</th>
                          <th>{{ translations('inventory.quantity') }}</th>
                          <th>{{ translations('inventory.unit_price') }}</th>
                          <th>{{ translations('inventory.amount_money') }}</th>
                        </tr>
                      </thead>
                      <tbody class="nowrap">
                        <tr v-for="(part) in productParent.childs" :key="part.id">
                          <td>{{ part.ean_code }}</td>
                          <td>{{ part.model }}</td>
                          <td class="right">{{ part.quantity }}</td>
                          <td class="right">{{ part.price }}</td>
                          <td class="right">{{ part.total_price }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <i class="fas fa-times cursor-pointer" @click="dropProduct(i)"></i>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" :disabled="!canExec" @click="detachProduct">{{ translations('inventory.product_disassembly') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VueElementLoading from 'vue-element-loading'
import 'vue-search-select/dist/VueSearchSelect.css'
import { WareHouse } from '@/constants'
import { mapState } from 'vuex'
export default {
  name: 'detachProductSetsConstructModal',
  components: {
  },
  props: {
    warehouseId: {
      type: Number,
      require: true
    },
    conditionId: {
      type: [Number, Array],
      require: true
    }
  },
  data () {
    return {
      product_sets: [],
      search: '',
      setting_at: null,
      comment: null,
      product_actives: [],
      indexOpenChild: -1,
      isLoading: true,
      activeSelect: null
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    canExec: function () {
      return this.product_actives.length > 0
    },
    productComputed: function () {
      return this.product_actives.map((parent) => {
        let childs = parent.childs.map(child => ({
          ...child,
          quantity: Number(parent.quantity_need_detach * child.need_quantity).toLocaleString(),
          price: Number(parent.quantity_need_detach * child.original_price_jpy).toLocaleString(),
          total_price: Number(parent.quantity_need_detach * child.need_quantity * child.original_price_jpy).toLocaleString()
        }))

        return {
          ...parent,
          childs,
          disabled: parent.quantity <= 0,
          nameCustom: this.nameAndModelTextProduct(parent)
        }
      })
    },
    productSetComputed: function () {
      return this.product_sets
        .filter(e => this.product_actives.every(item => item.id !== e.id))
        .map((parent) => {
          return {
            ...parent,
            disabled: parent.quantity <= 0,
            quantity_need_detach: 1,
            nameCustom: this.nameAndModelTextProduct(parent)
          }
        })
    }
  },
  watch: {
    setting_at: function () {
      this.getProducts()
    }
  },
  mounted () {
    let self = this
    window.$(this.$refs.vuemodal).on('shown.bs.modal', { self: this }, async () => {
      self.activeSelect = null
      self.getProducts()
    })
  },
  created: function () {
    this.setting_at = this.$invoiceTools.getCurrentDate()
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    toggleDropdown: function (i) {
      this.indexOpenChild = this.indexOpenChild === i ? -1 : i
    },
    async getProducts () {
      const self = this
      self.isLoading = true
      self.product_actives = []
      if (Number(self.warehouseId) === WareHouse.ALL_INVENTORY || Number(self.warehouseId) === WareHouse.ALL_CONSIGNMENT ||
        Number(self.warehouseId) === WareHouse.TOTAL_INVENTORY) return
      let params = {
        warehouse_id: self.warehouseId,
        detail: 1,
        setting_at: self.setting_at,
        condition: this.conditionId
      }
      let productSets = []
      try {
        let response = await self.$http.get(self.$api_url.products_sets, { params })
        productSets = response.data.data
      } catch (error) {
      }
      if (!productSets.length) self.$toastr.error('在庫数がありません')
      self.product_sets = productSets.map(e => ({
        ...e,
        nameCustom: this.nameAndModelTextProduct(e)
      }))
      self.isLoading = false
    },
    changeQuantityProduct (e, i) {
      let value = parseInt(e.target.value)
      this.onActionQuantity(i, value, true)
    },
    nameAndModelTextProduct (product) {
      return [product.ean_code, product.model, product.legacy_code].filter(Boolean).join(' - ')
    },
    detachProduct: async function () {
      // 組み立て処理
      const params = {
        warehouse_id: this.warehouseId,
        setting_at: this.setting_at,
        comment: this.comment,
        products: this.product_actives,
        condition: this.conditionId
      }
      try {
        await this.$http.post(this.$api_url.detach_product_sets, params)
        this.$toastr.success('', '製品分解処理が完了しました。')
        this.close()
      } catch (error) {
        console.log(error)
        this.$toastr.error('', '製品分解処理が失敗しました。')
      }
    },
    onSelectProduct: function (item) {
      this.activeSelect = null
      if (!item || item.quantity <= 0) return
      if (this.product_actives.length >= 10) {
        this.$toastr.error('最大、製品は１０セットまで分解処理できます。')
        return
      }
      this.product_actives.push(item)
    },
    dropProduct: function (i) {
      this.product_actives.splice(i, 1)
      this.indexOpenChild = -1
    },
    close: function () {
      window.$('#detachProductSetsConstructModal').modal('hide')
    },
    onActionQuantity (key, amount = 1, overwrite = false) {
      amount = parseInt(amount)
      if (!this.product_actives[key]) return
      if (overwrite) this.product_actives[key].quantity_need_detach = parseInt(amount)
      else this.product_actives[key].quantity_need_detach = parseInt(this.product_actives[key].quantity_need_detach) + amount
      if (this.product_actives[key].quantity_need_detach > this.product_actives[key].quantity) {
        this.$toastr.error('セット品数を再入力してください。')
        this.product_actives[key].quantity_need_detach = this.product_actives[key].quantity
      }

      if (this.product_actives[key].quantity_need_detach < 1) {
        this.$toastr.error('セット品の数は１以上数を入力してください')
        this.product_actives[key].quantity_need_detach = 1
      }
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.content-product-detach {
  min-height: 100px;
}
.action-quantity{
  width: 300px;
  margin-right: 4px;
}
.action-quantity input {
  width: 60px;
  border: none;
  border-bottom: 1px solid #ccc;
  border-radius: 0;
  text-align: center;
}
.action-quantity input:focus {
  box-shadow: none;
  border: none;
  border-bottom: 2px solid #8bb8df;
  border-radius: 0;
}
.action-quantity input:disabled{
  background: none;
}
.quanlity-max{
  width: 200px;
  margin-right: 4px;
}
.item-product {
  border-bottom:1px solid #dee2e6;
  /* width: 200px; */
}
.item-product:last-child {
  border: none;
}
.name-product{
  width: 350px;
  margin-right: 4px;
}
.action-quantity input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.open-child{
  position: relative;
  width: 150px;
}
.open-child .table{
  background: white;
  position: absolute;
  right: 0px;
  z-index: 10;
  box-shadow: 1px 1px 6px #868686;
}
.search-product {
  width: 300px;
}
.dropdown-toggle{
  width: 100%;
}
.option-product-set img{
  width: 24px;
  margin-bottom: 4px;
  margin-left: 20px;
}
</style>
